import { pdfjs } from 'react-pdf'

import type { PDFDocumentProxy } from 'pdfjs-dist'

import { downloadBlob } from 'modules/core/lib/download'

const getPdfBlob = async (pdf: PDFDocumentProxy): Promise<Blob> => {
  const data = await pdf.saveDocument()
  return new Blob([data as BlobPart], { type: 'application/pdf' })
}

const printPdf = async (pdf: PDFDocumentProxy | null): Promise<void> => {
  if (!pdf) return

  const blob = await getPdfBlob(pdf)
  const blobUrl = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  document.body.appendChild(iframe)

  iframe.style.display = 'none'
  iframe.src = blobUrl
  iframe.onload = function () {
    iframe.focus()
    iframe.contentWindow!.print()
  }
}

const downloadPdf = async (pdf: PDFDocumentProxy | null, filename: string): Promise<void> => {
  if (!pdf) return

  const blob = await getPdfBlob(pdf)
  downloadBlob(blob, filename)
}

const getPdfPages = async (file: File): Promise<number> => {
  const pdfDocument = await pdfjs.getDocument(URL.createObjectURL(file)).promise
  const { numPages } = pdfDocument
  return numPages
}

export interface PageSize {
  width: number
  height: number
}

const getPdfFileSizes = async (file: File, pagesNumber: number): Promise<PageSize[]> => {
  const pdfDocument = await pdfjs.getDocument(URL.createObjectURL(file)).promise
  const sizes: PageSize[] = []

  for (let page = 1; page <= pagesNumber; page++) {
    const pageSize = (await pdfDocument.getPage(page)).getViewport({ scale: 1 })
    const size = { width: pageSize.width || 0, height: pageSize.height || 0 }
    sizes.push(size)
  }

  return sizes
}

export { getPdfBlob, printPdf, downloadPdf, getPdfPages, getPdfFileSizes }
